import { render, staticRenderFns } from "./SharedMediaWithSpaceStorageMediaUnshare.vue?vue&type=template&id=c62a6856&"
import script from "./SharedMediaWithSpaceStorageMediaUnshare.vue?vue&type=script&lang=js&"
export * from "./SharedMediaWithSpaceStorageMediaUnshare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports